<template>
    <b-modal
        id="modal-batchselector"
        ref="modal"
        size="xl"
        :title="this.formtitle"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
        @change="change"
    >
        <b-card @submit.stop.prevent="handleSubmit">
            <b-alert
                v-model="showDismissibleAlert"
                variant="danger"
                dismissible
            >
                {{ alertText }}
            </b-alert>
            <period-selector
                id="selector-production"
                v-model="selectDays"
                v-bind:periodDays="periodeDagen"
                v-bind:forceToday="true"
                @change="setNewDates"
            />

            <b-table
                striped
                responsive
                :fields="visibleFields"
                :items="displayList"
                multi
                selectable
                ref="prodTable"
                @row-selected="onRowSelected"
                @refreshed="setSelected"
            >
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                    </template>
                </template>
            </b-table>
            <p>
                <b-button
                    size="sm"
                    v-if="erisselected"
                    @click="clearSelected"
                    >{{
                        $t('com_wisselectie', {
                            ns: 'common'
                        })
                    }}</b-button
                >
            </p>
            <b-button size="sm" v-if="!erisselected" @click="setSelected">{{
                $t('com_selecteer', {
                    ns: 'common'
                })
            }}</b-button>
        </b-card>
    </b-modal>
</template>
<script>
import DateHelper from '../../models/DateHelper';
import Helper from '../../models/Helper';
import { loadList, loadItem } from '../../models/DataHelper';
import PeriodSelector from '../components/PeriodSelector.vue';
export default {
    name: 'ProductionBatchSelector',
    data: function () {
        return {
            showDismissibleAlert: false,
            alertText: '',
            selectDays: null,
            periodeDagen: 1,
            selected: [],
            forcerefresh: true,
            van: null,
            tot: null,
            displayList: [],
            selectedObject: null
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        askedProdDate: {},
        askedProductID: {},
        askedProduct: {},
        requestedAmount: {},
        title: {
            type: String,
            default: ''
        }
    },
    watch: {},
    components: {
        PeriodSelector
    },
    computed: {
        formtitle() {
            return this.title + ' :  ' + this.askedProduct;
        },
        erisselected() {
            return this.selected.length > 1;
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'selected', label: ' ', sortable: false, visible: true },
                { key: 'actions', label: ' ', visible: false },
                { key: 'id', label: 'Id', sortable: false, visible: false },
                {
                    key: 'productieDatum',
                    label: this.$t('com_datum', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                { key: 'bakno', label: '#', sortable: true, visible: true },
                {
                    key: 'lotnummer',
                    label: 'BG#',
                    sortable: true,
                    visible: true
                },
                {
                    key: 'kaasnaam',
                    label: this.$t('com_kaassoort', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'aantal',
                    label: this.$t('com_number', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'orders',
                    label: this.$t('com_salesorders', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'assigned',
                    label: this.$t('prod_assigned', { ns: 'production' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        hide() {
            this.$emit('hide');
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        async checkFormValidity() {
            if (this.selected.length === 0) {
                this.showAlert(
                    this.$t('com_geen_data', {
                        ns: 'common'
                    })
                );
                return false;
            }
            let gaDoor = true;
            let warnString = '';
            for (let i = 0; i < this.selected.length; i++) {
                const item = this.selected[i];
                const opVoorraad = item.aantal - (item.assigned ?? 0);   
                const marge = opVoorraad - this.requestedAmount             
                if (marge < 0) {
                    warnString = Helper.concatString(
                        warnString,
                        Helper.stringformat(
                            this.$t('prod_verkoopmeerdanplan', {
                                ns: 'production'
                            }),
                            this.requestedAmount,
                            opVoorraad
                        )
                    );
                }
            }
            if (warnString != '') {
                gaDoor = await this.$root.showConfirmationBox(warnString);
            }
            return gaDoor;
        },
        async handleSubmit() {
            if (!(await this.checkFormValidity())) {
                return;
            }
            // Hide the modal manually
            this.$nextTick(() => {
                this.$emit(
                    'input',
                    this.selected.map((x) => x.id)
                );
                this.$bvModal.hide('modal-batchselector');
            });
        },
        async loadData() {
            this.clearSelected();
            this.displayList = [];
            const selectionData = {
                from: DateHelper.localDateToUTC(this.van),
                until: DateHelper.localDateToUTC(this.tot ?? this.van)
            };
            const lijstBakken = await loadList(
                'production/getBatchInfoHistLijst',
                'production/loadBatchInfoOverPeriod',
                selectionData,
                this.forcerefresh,
                this.$t
            );
            if (lijstBakken.length == 0) return;
            const lijstAssigned = await loadItem(
                'salesorder/loadSalesOrderBatchInfo',
                selectionData,
                this.$t
            );
            const baseList = lijstBakken.filter(
                (x) => x.uitpekeltijdOri == null && x.productID == this.askedProductID
            );
            for (let i = 0; i < baseList.length; i++) {
                const item = baseList[i];
                const shortlist = lijstAssigned.filter(
                    (x) => x.batchID == item.id
                );
                const assigned = shortlist
                    .map((x) => x.assigned)
                    .reduce((temp, a) => temp + a, 0);
                const orders = shortlist
                    .map((x) => x.orders)
                    .reduce((temp, a) => temp + a, 0);
                item.orders = orders;
                if (assigned > 0) {
                    item.assigned = assigned;
                }
            }
            this.displayList = baseList;
            this.setSelected();
        },
        setSelected() {
            if (this.selectedObject == undefined)
                this.selectedObject = this.displayList.find(
                    (item) => item.productID == this.askedProductID
                );
            const tafel = this.$refs.prodTable;
            this.$nextTick(() => {
                const i = this.displayList.indexOf(this.selectedObject);
                tafel.selectRow(i);
                this.selected = [this.selectedObject];
            });
        },
        setNewDates(selDates) {
            this.van = selDates.van;
            this.tot = selDates.tot;
            this.loadData();
        },
        onRowSelected(items) {
            this.selected = items;
        },
        clearSelected() {
            this.selectedObject = null;
            if (this.$refs.prodTable) this.$refs.prodTable.clearSelected();
        },
        change(visible) {
            this.$emit('change', visible);
        }
    },
    mounted() {},
    async created() {
        this.van =
            this.askedProdDate != undefined
                ? DateHelper.convertedToDateTimeJS(this.askedProdDate)
                : new Date().toISOString().split('T')[0];
        this.tot = this.van;
        await this.loadData();
    }
};
</script>

<style scoped>
::v-deep .table > tbody > tr.b-table-row-selected,
::v-deep .table > tbody > tr.b-table-row-selected > td,
::v-deep .table > tbody > tr.b-table-row-selected > th {
    background-color: #00a1de;
    color: ghostwhite !important;
}
.overflow-class /deep/ .dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
}
</style>

